import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";
import { setRegPage } from "../../../action/action";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import MiniLoader from "../../UI/MiniLoader";
import { scrollToTop } from "../../../JS/scrollToTop";
import Gha_WelcomePage from "./Gha_WelcomePage";
import Gha_NewJoin from "./Gha_NewJoin";
import Gha_Login from "./Gha_Login";
 





const Gha_Welcome = (props) => {

    // const [props.currentPage, setCurrentPage]=useState(1);
    // const [props.isNewJoin, setIsNewJoin]=useState(false);

    

    const { t } = props;


   
   
    useEffect(() => {

        scrollToTop();


    }, []);


    return (

        <>

            {props.currentPage == 1 && <Gha_WelcomePage handleNext={props.handleNext} handleGoBack={props.handleGoBack}  pageContent={props.pageContent} />}
        {props.currentPage == 2 && 
         ( props.isNewJoin 
                ? <Gha_NewJoin handleNext={props.handleNext} handleGoBack={props.handleGoBack} fetchingLang={props.fetchingLang} availableLanguages={props.availableLanguages} requiredLinks={props.requiredLinks} isLangFetchingFailed={props.isLangFetchingFailed}  />
                : <Gha_Login handleNext={props.handleNext} handleGoBack={props.handleGoBack} />
         )
         }

        </>
    );
};

const mapStateToProps = (state) => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
         logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",
    };
};

export default connect(mapStateToProps, { setGoHome, closeOrderPopUp, sendAnalytics })(
    withTranslation("translations")(Gha_Welcome)
);
